import clsx from 'clsx';

import LoadingIcon from 'assets/images/Loading.svg';

import styles from './styles.module.scss';

type IProps = {
  className?: string;
  children?: React.ReactNode;
};

export const LoaderArrow = ({ className, children = 'Loading...' }: IProps) => {
  return (
    <div className={clsx(styles.root, className)}>
      <img src={LoadingIcon} alt="" className={styles.loadingImg} />
      <div className={styles.text}>{children}</div>
    </div>
  );
};
